
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import IconVip from '@mg/web-components/Atoms/Icon/IconVip'
import AccountMenu from '@mg/web-components/Account/AccountMenu'
import IconUserOutline from '@mg/web-components/Atoms/Icon/IconUserOutline.vue'
import IconSmartFreeDelivery from '@mg/web-components/Atoms/Icon/IconSmartFreeDelivery.vue'
import { GQLMenu, GQLUser } from '~/graphql/__generated__/interfaces'
import {
  GQLLocalAccount,
  GQLLocalOpenHeaderEnum,
} from '~/graphql/__generated__/interfacesLocal'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import getVipIcon from '~/utils/getVipIcon'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { GET_MENU_ITEM_FULL } from '~/graphql/gql/menu'
import { getMenuVariables } from '~/utils/getMenuVariables'
import ApolloFetchPolicies from '~/utils/apolloFetchPolicies'

@Component<HeaderUserSignedMobile>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    getUserMenu: {
      fetchPolicy: ApolloFetchPolicies.CACHE_ONLY,
      query: GET_MENU_ITEM_FULL,
      update(data: { getMenu: GQLMenu }) {
        return data.getMenu
      },
      variables() {
        return getMenuVariables(
          'kc',
          this.$route.query.naviPreview as string,
          this.$shopConfig.abTests.abTestsData.menuAbTest,
          false
        )
      },
    },
    user: {
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user.id && !this.account?.isLogged
      },
    },
  },
  components: {
    IconVip,
    IconUserOutline,
    IconSmartFreeDelivery,
    AccountMenu,
  },
  filters: {
    name: ({ lastName, firstName }: GQLUser) => `${firstName} ${lastName}`,
    shortName: ({ lastName, firstName }: GQLUser) =>
      `${firstName} ${lastName?.slice(0, 1) ?? ''}.`,
  },
})
export default class HeaderUserSignedMobile extends Vue {
  user: GQLUser
  account: GQLLocalAccount
  getUserMenu: GQLMenu
  @Prop(Boolean) isOpenState: boolean
  getVipIcon = getVipIcon

  openToggle(event: Event) {
    event.stopPropagation()
    this.isOpenState ? this.closed() : this.open()
  }

  open() {
    this.changeTab(GQLLocalOpenHeaderEnum.User)
  }

  closed() {
    this.closeTab()
  }

  @Emit('changeTab')
  changeTab(tabName: null | GQLLocalOpenHeaderEnum) {
    return tabName
  }

  @Emit()
  closeTab() {}

  async logout(event: Event) {
    event.preventDefault()
    await this.$webApi.logout()
    window.location.replace('/')
  }

  get shouldDisplayVipBadge() {
    return !!this.user && this.user.vipType
  }

  get shouldShowSmartIcon() {
    const smartClubId = this.$shopConfig.webConfig.mallSmartClubId
    return this.user?.clubs?.find((club) => {
      return club.id === smartClubId && club.status === 'A'
    })
  }

  get translations() {
    return {
      hdg_widget_is_vip: this.$t('common.hdg_widget_is_vip'),
      account: this.$t('common.cta_customer_account'),
      logout: this.$t('common.logout'),
    }
  }
}
